import { getQuery } from '@/utils/utils'

// ! 调试本地的i18n的语言切换使用
export const LanguageRedirection = () => {
  if (!process.client) return
  const querys = 'lang'
  const _search = window.location.search
  let values = ''
  const languageList = [
    'de_DE',
    'en_IN',
    'en_PH',
    'en_US',
    'es_ES',
    'fr_FR',
    'hi_IN',
    'in_ID',
    'it_IT',
    'ms_MY',
    'pt_BR',
    'ru_RU',
    'zh_CN',
    'th_TH',
  ]

  if (_search.indexOf(querys) !== -1) {
    values = getQuery(querys) || ''
    const result = languageList.find((item) => {
      if (values && item.toLowerCase().indexOf(values.toLowerCase()) !== -1) {
        return item
      }
      return null
    })
    values = result || 'en_US'
  }
  return values
}
